import { render } from "./AgendaContainer.vue?vue&type=template&id=673ae723&scoped=true"
import script from "./AgendaContainer.vue?vue&type=script&lang=js"
export * from "./AgendaContainer.vue?vue&type=script&lang=js"

import "./AgendaContainer.vue?vue&type=style&index=0&id=673ae723&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673ae723"]])

export default __exports__